export default {
  // 语言选择
  'settings.language.chinese': '中文',
  'settings.language.english': 'English',

  // 服务类型
  'settings.service.remitToChina': '汇入中国',
  'settings.service.digitalWallet': '数字钱包',

  // 条款和条件
  'settings.terms.title': '服务条款',
  'settings.terms.title.label': '标题',
  'settings.terms.content.label': '内容',

  // 隐私政策
  'settings.privacy.title': '隐私政策',
  'settings.privacy.content.label': '内容',

  // 内容类型
  'settings.content.type.manual': '手动编辑',
  'settings.content.type.link': '外部链接',

  // 内容类型描述
  'settings.content.manual.description': '编辑双语内容，系统会根据用户语言环境自动显示对应版本',
  'settings.content.link.description': '提供外部链接，用户点击时将在新窗口打开',

  // 链接相关
  'settings.content.link.placeholder': 'https://example.com/terms',
  'settings.content.link.preview': '预览链接',
  'settings.content.link.error': '请输入有效的URL地址',

  // 验证消息
  'settings.validation.required.zh': '请输入中文内容',
  'settings.validation.required.en': '请输入英文内容',

  // 通用操作
  'common.save': '保存',
  'common.cancel': '取消',
  'common.edit': '编辑',
  'common.preview': '预览',
  'common.confirm': '确认',

  // ==================== 数字钱包设置 ====================
  // 页面标题
  'settings.wallet.title': '数字钱包白标配置',
  'settings.wallet.description': '自定义您的数字钱包品牌外观，包括Logo、主题色、Slogan等',

  // Logo配置
  'settings.wallet.logo': 'Logo',
  'settings.wallet.logo.hint': '推荐尺寸: 200x200px，支持 PNG/JPG 格式',

  // 主题配色
  'settings.wallet.colors': '主题配色',
  'settings.wallet.colors.preset': '快速选择',
  'settings.wallet.color.primary': '主题色',
  'settings.wallet.color.primary.hint': '用于按钮、链接等主要元素',
  'settings.wallet.color.secondary': '辅助色',
  'settings.wallet.color.secondary.hint': '用于强调、成功状态等',

  // 背景图
  'settings.wallet.background': '背景主视觉',
  'settings.wallet.background.hint': '推荐尺寸: 1920x1080px，支持 PNG/JPG 格式',

  // 品牌Slogan
  'settings.wallet.slogan': '品牌Slogan',
  'settings.wallet.slogan.label': 'Slogan文案',

  // 支付页配置
  'settings.wallet.page.title': '页面标题',
  'settings.wallet.page.description': '页面描述',
  'settings.wallet.page.button': '按钮文字',
  'settings.wallet.successPage': '支付成功页',
  'settings.wallet.successPage.config': '成功页配置',
  'settings.wallet.failurePage': '支付失败页',
  'settings.wallet.failurePage.config': '失败页配置',

  // 操作按钮
  'settings.wallet.export': '导出配置',
  'settings.wallet.export.success': '配置导出成功',
  'settings.wallet.reset': '重置配置',
  'settings.wallet.reset.success': '已重置为默认配置',
};
